// Google Fonts that each ship a regular and a bold weight, so one request with
// both weights always succeeds and headings never fall back to a faked bold.
export const FONTS = [
  { family: 'Inter', kind: 'sans-serif' },
  { family: 'Roboto', kind: 'sans-serif' },
  { family: 'Open Sans', kind: 'sans-serif' },
  { family: 'Lato', kind: 'sans-serif' },
  { family: 'Montserrat', kind: 'sans-serif' },
  { family: 'Source Sans 3', kind: 'sans-serif' },
  { family: 'Nunito', kind: 'sans-serif' },
  { family: 'Poppins', kind: 'sans-serif' },
  { family: 'Work Sans', kind: 'sans-serif' },
  { family: 'Merriweather', kind: 'serif' },
  { family: 'Lora', kind: 'serif' },
] as const

export type Font = (typeof FONTS)[number]['family']

export const DEFAULT_FONT: Font = 'Inter'

export function fontStack(font: Font) {
  // The embed page already loads Inter for the app's own font stack.
  if (font === DEFAULT_FONT) return "'Inter var', ui-sans-serif, system-ui, sans-serif"
  const kind = FONTS.find(({ family }) => family === font)?.kind ?? 'sans-serif'
  return `'${font}', ui-${kind}, system-ui, ${kind}`
}

// `.tailwind *` makes every element inherit its font with !important, and the embed
// page's body font class is !important too, so a chosen font only holds as important.
export function setFont(element: HTMLElement, font: Font) {
  element.style.setProperty('font-family', fontStack(font), 'important')
}

// A stylesheet added after the page loads never holds up the events, and
// display=swap shows the text in the fallback until the font arrives.
export function loadFont(font: Font) {
  if (font === DEFAULT_FONT) return
  const href = `https://fonts.googleapis.com/css2?family=${font.replace(/ /g, '+')}:wght@400;700&display=swap`
  if (document.head.querySelector(`link[href="${href}"]`)) return
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = href
  document.head.appendChild(link)
}
